import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IGiftcardTrackingData } from './models/IGiftcardTrackingData'
import {
  getGiftcardIdentityTrackingDetails,
  getGiftcardTrackingDetails,
} from './utils'

export function sentGiftcardPaymentComplete(transactionId?: string) {
  try {
    const metrics = getMetrics()
    metrics.api.identify(getGiftcardIdentityTrackingDetails())
    metrics.api.track(
      EventTypes.GIFTCARD_PURCHASE,
      getGiftcardTrackingDetails(transactionId),
    )
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

export function FacebookGiftcardPurchase(data: IGiftcardTrackingData): any {
  return {
    value: data.total_value,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.trip_type,
    content_category: data.category,
    country: data.country,
  }
}

export function AdWordsGiftcardPurchase(data: IGiftcardTrackingData): any {
  return {
    sendTo: '1ZDqCJDus4MBEPn5ucwD',
    value: data.total_value,
    currency: data.currency,
  }
}

export function GoogleGiftcardPurchase(data: IGiftcardTrackingData): any {
  return {
    value: data.total_value,
    currency: data.currency,
    items: [
      {
        id: data.trip_id,
        name: data.trip_type,
        category: data.category,
        price: data.total_value,
        quantity: 1,
        dimension17: data.country,
        dimension18: data.coupon,
      },
    ],
  }
}

export function SnapchatGiftcardPurchase(data: IGiftcardTrackingData): any {
  return {
    price: data.total_value,
    currency: data.currency,
    transaction_id: data.transaction_id,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}

export function BingGiftcardPurchase(data: IGiftcardTrackingData): any {
  return {
    event_category: 'purchase',
    event_action: 'purchase',
    event_label: 'giftcard',
    event_value: data.total_value,
  }
}
